"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  plan: {
    missingProduct: 'Please select a product',
    missingFeature: 'Please select a feature',
    missingName: 'Please enter a descriptive name',
    missingSummary: 'Please enter a summary/description',
    missingHypothesis: 'Please enter a hypothesis',
    missingLength: 'Please enter an experiment length',
    missingType: 'Please select an experiment type',
    targetSampleSizeNotNumber: "Please enter a integer > 0 and < the world's population",
    minimumCharacterError: name => `Please add ${name} with minimum of 35 characters.`,
    lengthLimitError: 'An experiment must be between 1-180 days in length'
  },
  roles: {},
  variants: {
    missingTitle: 'Please enter a title',
    missingDescription: 'Please enter a description',
    missingContent: 'Please select a content'
  },
  metrics: {
    mustHaveOneLevelOne: 'You must select one success metric.',
    mustNotHaveDuplicateMetrics: 'You must not select the same metric twice.',
    hasJustOneLevelOne: 'You must select only a single success metric.'
  },
  techSettings: {
    productMinVersionRequired: 'Please enter a min version',
    productMinVersionFormatError: 'Min version must match x.x.x format',
    productMaxVersionRequired: 'Please enter a max version',
    productMaxVersionFormatError: 'Max version must match x.x.x format',
    updateExperimentTechSettingsError: 'We were unable to update the tech settings on your experiment.  Please try again in a few minutes.'
  },
  experimentOverrides: {
    missingVariant: 'Please select a variant'
  },
  sampleLaunch: {
    productionRunningError: 'You cannot reduce your allocation to zero once your experiment is running',
    errorOneVariantWithWeightAboveZero: 'You must have at least one variant with a weight greater than zero'
  },
  overrideManagement: {
    missingOverrideName: 'Please enter an ID name',
    missingOverrideID: 'Please enter an ID',
    missingIDType: 'Please select an ID type',
    missingProduct: 'Please select a product',
    missingOverrideGroupName: 'Please enter a group name',
    missingOverrideGroupIds: 'Please select at least one override'
  }
};
exports.default = _default;